import React, { Component } from 'react';
import capitalize from 'lodash/capitalize';

class VersionTag extends Component {
  getBackgroundColor(){
    const {environment} = this.props;

    if(environment === 'prod') return '#ff4d4d';
    if(environment === 'demo') return '#18dcff';
    if(environment === 'test') return '#32ff7e';
    return '#ffaf40';
  }

  render(){
    const {environment,frontend,backend} = this.props;

    if(!environment || environment === 'prod') return (<div></div>)
    return (
      <div 
        className='VersionTag'
        style={{backgroundColor:this.getBackgroundColor()}}
      >
        <strong>Ad Manager: </strong>{frontend}<br />
        <strong>Services: </strong>{backend}<br />
        <strong>Environment: </strong>{capitalize(environment)}<br />
      </div>
    )
  }
}

export default VersionTag;


// WEBPACK FOOTER //
// ./src/shared/components/VersionTag/VersionTag.js